import React, { forwardRef, memo, useEffect, useImperativeHandle, useState } from 'react'
import { SwipeableDrawer, Tooltip } from '@mui/material'
import * as OnboardEntity from '../../../Entities/OnBoardingContainerTypes'
import VerticalTimelineComponent from './VerticalTimelineComponent'
import { IoIosCloseCircleOutline } from 'react-icons/io'

function VerticalTimeline ({ timelineType, data, apiCall }, ref) {
    const [ windowWidth, setWindowWidth ] = useState(window.innerWidth)
    const [ editState, setEditState ] = useState({ right: false })
    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    useEffect(() => {
        if (editState.right) apiCall()
    }, [editState])
    useImperativeHandle(ref, () => {
        return {
            toggleDraw: () => {
                toggleDrawer('right', true)()
            }
        }
    }, [])
    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event &&
               event.type === OnboardEntity.KEYDOWN &&
               (event.key === OnboardEntity.TAB || event.key === OnboardEntity.SHIFT)
        ) {
            return
        }
        setEditState({ ...editState, [anchor]: open })
    }
    return (
        <>
            <SwipeableDrawer
                PaperProps={{ sx: { width: windowWidth / 3, overflowX: 'hidden', zIndex: 0 } }}
                className='m-2 z-auto'
                anchor={'right'}
                open={editState.right}
                onClose={toggleDrawer('right', false)}
                onOpen={toggleDrawer('right', true)}
            >
                <div className='h-full  !bg-card'>
                    <div className='flex border-b-[1px] pb-3 p-4 items-center justify-between'>
                        <h2 className="text-h0 font-bold  text-primary" >{ timelineType + ' ' + 'Timeline'}</h2>
                        <Tooltip title="Close" placement="left" arrow componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <div className='cursor-pointer' onClick={toggleDrawer('right', false)}><IoIosCloseCircleOutline className='text-[hsl(var(--primary))]' size={25} /></div>
                        </Tooltip>
                    </div>
                    <VerticalTimelineComponent data={data} />
                </div></SwipeableDrawer>
        </>
    )
}

export const VerticalTimelineContainer = memo(forwardRef(VerticalTimeline))
